import React from 'react';

const HomePage = () => (
  <div className="home-page">
    <h1>Home</h1>
  </div>
);

export default HomePage;
